import type { SWRConfigInterface } from "@gik/core/api/BaseAPIConfig";
import { wpApi } from "@gik/core/api/ky/wpApi";
import { useWPApi } from "@gik/core/api/swr/useWPApi";
import type WordpressFeaturedContent from "@gik/core/models/wordpress/WordpressFeaturedContent";

const path = "featured-content";

export interface FeaturedContentParams {
	_fields?: string[];
}

export function getFeaturedContent(params?: FeaturedContentParams) {
	return wpApi
		.get(path, {
			searchParams: {
				...(params?._fields?.length > 0
					? { _fields: params._fields.join(",") }
					: {}),
			},
		})
		.json<WordpressFeaturedContent[]>();
}

export function useFeaturedContent(
	params?: FeaturedContentParams,
	config?: SWRConfigInterface,
) {
	return useWPApi<WordpressFeaturedContent[]>(
		path,
		{
			...(params?._fields?.length > 0
				? { _fields: params._fields.join(",") }
				: {}),
		},
		config,
	);
}
